import * as React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Cell: React.FC<Props> = (props) => {
  return <div className={`px-2 py-[6px] ${props.className}`}>{props.children}</div>;
};
Cell.displayName = 'AddContainers.RecentlyAdded.Table.Cell';
